export default "__VITE_ASSET__DYSbaXuO__"